var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.9985 0C29.5489 0 0 29.5498 0 65.9993C0 102.448 29.5489 132 65.9985 132C102.448 132 131.999 102.448 131.999 65.9993C131.999 29.5498 102.448 0 65.9985 0ZM65.9998 23.1821L105.056 47.5363H26.9437L65.9998 23.1821ZM105.543 86.427H105.539C105.539 90.3334 102.373 93.4987 98.4668 93.4987H33.5327C29.6264 93.4987 26.461 90.3329 26.461 86.427V49.086C26.461 48.6729 26.5032 48.2711 26.5719 47.8764L63.8878 71.1452C63.9335 71.1738 63.9824 71.1932 64.0294 71.2196C64.0787 71.2468 64.1289 71.2732 64.179 71.2983C64.4426 71.4343 64.7141 71.5438 64.9917 71.6156C65.0203 71.6235 65.0489 71.627 65.0775 71.6336C65.382 71.7053 65.6905 71.7502 65.9985 71.7502H66.0007C66.0029 71.7502 66.0051 71.7502 66.0051 71.7502C66.3131 71.7502 66.6215 71.7066 66.926 71.6336C66.9546 71.6266 66.9832 71.6235 67.0118 71.6156C67.289 71.5438 67.5596 71.4343 67.8245 71.2983C67.8746 71.2732 67.9248 71.2468 67.9741 71.2196C68.0207 71.1932 68.07 71.1738 68.1158 71.1452L105.432 47.8764C105.5 48.2711 105.543 48.672 105.543 49.086V86.427Z",
    fill: "url(#paint0_linear_29_74)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_74",
    x1: 65.9996,
    y1: 0,
    x2: 65.9996,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1d14079b981606e34cb9f31547544fce.svg";
export { ForwardRef as ReactComponent };